.bar {
  position: fixed;
  right: var(--tabbar-gap);
  bottom: calc(
    var(--tabbar-gap) +
    var(--tg-viewport-safe-area-inset-bottom, env(safe-area-inset-bottom, 0px)) +
    var(--tg-viewport-content-safe-area-inset-bottom, 0px)
  );
  left: var(--tabbar-gap);
  /* Высота задана, а не выведена из содержимого: от неё считаются
     нижний отступ страницы и положение подсказки о прокрутке. */
  height: var(--tabbar-height);
  z-index: 10;
  display: flex;
  gap: 4px;
  padding: 6px;
  /* Матовое стекло: содержимое под панелью просматривается, но не спорит
     с подписями вкладок. Полностью непрозрачный фон превращал панель
     в дно экрана — тогда терялся признак того, что страница продолжается. */
  background: var(--tabbar-bg);
  backdrop-filter: blur(var(--tabbar-blur));
  border: 1px solid var(--card-border);
  border-radius: var(--tabbar-radius);
  /* Тень мягче обычной плавающей: панель теперь стоит на растворённом
     фоне, и сильная тень поверх градиента выглядит грязью. */
  box-shadow: 0 2px 8px rgb(20 22 28 / 6%), 0 10px 26px rgb(20 22 28 / 8%);
}

.item {
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 8px 0 6px;
  background: none;
  border: 0;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 500;
  color: var(--muted);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: color 0.15s ease, background-color 0.15s ease;
}

.active {
  color: var(--ink);
  background: var(--surface-sunken);
  box-shadow: inset 0 0 0 1px var(--card-border);
}

/*
 * Мягкое растворение содержимого у нижнего края.
 *
 * Идёт до самого низа экрана, а не до кромки таббара. Полоса, обрывающаяся
 * на панели, оставляла под ней снова чёткое содержимое — стык читался как
 * границы мутного прямоугольника.
 *
 * Градиент длинный и без резких остановок: плотная часть занимает нижнюю
 * треть, дальше плавное исчезновение. Короткий градиент с быстрым набором
 * плотности выглядит наложенной полосой, а не растворением.
 *
 * Слой ниже панели (z-index 8 против 10): сама панель остаётся чёткой.
 *
 * Без JS: когда список прокручен до конца, под градиентом пустой фон,
 * и он не виден. Значит показывать его всегда — честно.
 */
.fade {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 8;
  height: var(--fade-height);
  pointer-events: none;
  background: linear-gradient(
    to top,
    var(--bg) 0%,
    var(--bg) var(--fade-solid),
    transparent 100%
  );
}

/* Широкий экран: таббар держится колонки приложения, а не краёв окна. */
@media (min-width: 640px) {
  .bar {
    right: calc(50% - var(--column) / 2 + var(--tabbar-gap));
    left: calc(50% - var(--column) / 2 + var(--tabbar-gap));
  }
}
